import { render, staticRenderFns } from "./OurBeliefsEducationSection.vue?vue&type=template&id=2d17d430"
import script from "./OurBeliefsEducationSection.vue?vue&type=script&lang=ts"
export * from "./OurBeliefsEducationSection.vue?vue&type=script&lang=ts"
import style0 from "./OurBeliefsEducationSection.vue?vue&type=style&index=0&id=2d17d430&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports